// Components==============
import indexActivities from 'actions/activity/index';
import indexPhases from 'actions/phase/index';
import indexProjectGroup from 'actions/project-group/index';
import indexProject from 'actions/project/index';
import indexTheme from 'actions/theme/index';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import ReflectionCard from 'components/UI/ProjectCard/components/Card/ReflectionCard';
import Title from 'components/UI/Title/Title';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import { useTranslate } from 'hooks/useTranslate';
import Invite from 'pages/Workspace/MyProjects/Invite/Invite';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './Judge.module.scss';
// =========================

export default function Judge() {
  const dispatch = useDispatch();
  const translate = useTranslate();

  useEffect(() => {
    dispatch(indexTheme());
    dispatch(indexProject());
    dispatch(indexProjectGroup());
    dispatch(indexActivities());
    dispatch(indexPhases());
  }, []);

  const loading = useRedux(
    (state) =>
      state.theme?.loading ||
      state.project?.loading ||
      state.projectGroup?.loading ||
      state.activity?.loading ||
      state.phase?.loading
  );

  const userId = useRedux((state) => state.authentication?.user?.id);

  const unfilteredThemesWithProject = useThemesWithProject();

  const themesWithProject = unfilteredThemesWithProject.filter((theme) => {
    const studentCount = theme?.allProjects?.filter((p) =>
      p.members
        .filter((m) => m.membership === 'teacher' || m.membership === 'extern')
        .map((m) => m.user_id)
        .includes(userId || 0)
    );

    return studentCount && studentCount?.length > 0;
  });

  const invites = useRedux((state) =>
    state.reflection?.entities.allIds
      .map((id) => state.reflection?.entities.byId[id])
      ?.filter(
        (reflection) =>
          reflection?.user.id === userId &&
          !!reflection?.for_user &&
          !reflection?.finished
      )
      // fix bug where reflection doesn't refer to any existing project
      .filter((reflection) => !!reflection?.project_process)
  );

  const isExtern = usePermission(['Extern']);

  return (
    <Layout>
      <NoContent
        loading={!!loading}
        hasContent={
          !!(invites?.length || themesWithProject.length) ||
          !!(isExtern && unfilteredThemesWithProject?.length > 0)
        }
        page="judge"
      >
        <Container>
          <Title text="general.terms.feedback-request" loading={loading} />
          {!!invites?.length && (
            <div styleName="wrapper">
              {invites.map(
                (invite, i) =>
                  !!invite && (
                    <Invite key={i} reflection={invite} type="reflection" />
                  )
              )}
            </div>
          )}
          {!!invites?.length && (
            <h1 styleName="secondary-title">
              {translate('general.terms.feedback')}
            </h1>
          )}
          <div styleName="wrapper">
            {isExtern ? (
              <>
                {unfilteredThemesWithProject.map((theme) => (
                  <ReflectionCard key={theme?.id} theme={theme} />
                ))}
              </>
            ) : (
              <>
                {themesWithProject.map((theme) => (
                  <ReflectionCard key={theme?.id} theme={theme} />
                ))}
              </>
            )}
          </div>
        </Container>
      </NoContent>
    </Layout>
  );
}
